import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { LegacySection } from './components/LegacySection';
import { BankLieSection } from './components/BankLieSection';
import { ThreePillarsSection } from './components/ThreePillarsSection';
import { SecretSection } from './components/SecretSection';
import { LiberationSection } from './components/LiberationSection';
import { ProductShowcase } from './components/ProductShowcase';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/ui/SectionDivider';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-gray-200 font-sans selection:bg-gold-500/30 selection:text-gold-300 overflow-x-hidden" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />

        <SectionDivider data-id="element-4" />

        <PainSection data-id="element-5" />
        <LegacySection data-id="element-6" />

        <SectionDivider data-id="element-7" />

        <BankLieSection data-id="element-8" />
        <ThreePillarsSection data-id="element-9" />

        <SectionDivider data-id="element-10" />

        <SecretSection data-id="element-11" />
        <LiberationSection data-id="element-12" />

        <SectionDivider data-id="element-13" />

        <ProductShowcase data-id="element-14" />
        <TestimonialsSection data-id="element-15" />

        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
    </div>;
}